// test483
(483 && 0);
